module.exports = __webpack_public_path__ + "img/news.7d15c370.jpg";